<template>
  <div class="container is-fluid">
    <div class="columns" v-if="fileArr.length == 0">
      <div class="column">
        <FolderDropzone />
      </div>
    </div>
    <div v-if="fileArr.length > 0">
      <div class="columns">
        <div class="column">
          <div class="field">
            <input
              v-model="currentTag"
              v-on:keyup.enter="addTags"
              class="input"
              type="text"
              placeholder="Enter space-separated tags and hit enter to add"
            />
          </div>
        </div>
        <div class="column nogrow">
          <button class="button is-primary" v-on:click="upload">
            <span class="icon">
              <i class="im im-upload" style="font-size: 14px;"></i>
            </span>
            <span>Upload</span>
          </button>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <div class="image-tags">
            <a
              class="tag is-primary"
              v-for="(_, tag) in allTags"
              :key="tag"
              v-on:click="onAllTagClick(tag)"
            >{{ tag }}</a>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div
          class="column is-3"
          v-for="(image, idx) in fileArr"
          :key="image.webkitRelativePath"
          v-on:click.exact="imageClick({idx})"
          v-on:click.ctrl="imageCtrlClick({idx})"
          v-on:click.shift="imageShiftClick({idx})"
        >
          <div class="thumbnail-wrapper">
            <UploadImage
              v-bind:image="image"
              v-on:tag-click="$event => onTagClick(image.id, $event)"
            ></UploadImage>
            <div v-if="image.marked" class="mark-overlay"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImage from "../components/UploadImage.vue";
import FolderDropzone from "../components/FolderDropzone.vue";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      currentTag: ""
    };
  },
  computed: mapState("uploadFiles", ["fileArr", "allTags"]),
  components: {
    UploadImage,
    FolderDropzone
  },
  methods: {
    onAllTagClick(tag) {
      console.log("should delete from all:", tag);
      this.$store.dispatch("uploadFiles/delTagFromAll", tag);
    },
    onTagClick(imageId, tag) {
      this.$store.dispatch("uploadFiles/delTagFromFile", {
        id: imageId,
        tag: tag
      });
    },
    addTags() {
      let tags = new Set(
        this.currentTag.split(" ").filter(e => e.trim() != "")
      );
      this.$store.dispatch("uploadFiles/addTagsToFiles", { tags });
      this.currentTag = "";
    },
    ...mapActions("uploadFiles", [
      "imageClick",
      "imageCtrlClick",
      "imageShiftClick",
      "upload"
    ])
  }
};
</script>
